import { TenantOptionsDetails } from "features/types";

export const getMaxSeatsAllowedPerReservation = (
  tenantConfig: TenantOptionsDetails | undefined
) => {
  return tenantConfig?.numOfSeatsAllowedPerReservation || 12;
};
